import styled, { keyframes } from 'styled-components';
import { FaSpinner } from 'react-icons/fa'

export const Overlay = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  height: ${({ isOpen }) => (isOpen ? '90%' : '0')};
  transition: all 0.3s ease;
  overflow: hidden;
  z-index: 1000;
  background: white;

/* Add border + rounded edges */
  border: 2px solid #006ee6;   /* pick a color that matches your theme */
  border-radius: 12px;         /* adjust radius for more/less rounding */
  box-shadow: 0 4px 12px rgba(0,0,0,0.15); /* optional: subtle shadow */

  /* Desktop / non-mobile: side pinned */
  @media (min-width: 601px) {
    top: auto;
    bottom: 5%;
    left: 5%;
    right: auto;
    width: ${({ isOpen }) => (isOpen ? '25%' : '0')};
    height: 90%;
  }
    

  /* Mobile: bottom pinned */
  @media (max-width: 600px) {
    width: 97%;
    height: ${({ isOpen }) => (isOpen ? '60%' : '0')};
    bottom: 90px;
    left: 0;
  }
`;


export const AIWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: white;
  justify-content: center;
`;

export const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const SpinningIcon = styled(FaSpinner)`
  // position: fixed;
  // margin-right: 25px;
  font-size: 24px;
  font-weight: bold;
  animation: 2s linear ${spin} infinite;
  z-index: 9999;
  color: black;
`;
export const FormH1 = styled.h1`
  margin: 0;
  padding: 1rem;
  background-color: white;
  color: #006ee6;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  border-bottom: 1px solid #ddd;
`;

export const History = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  background-color: #f9f9f9;

  @media (min-width: 601px) {
    max-width: 100%; /* use full sidebar width */
    margin-left: 0;
  }
`;

export const Message = styled.div`
  margin-right: 20px;
  align-self: ${(props) => (props.role === "user" ? "flex-end" : "flex-start")};
  margin-bottom: 1rem;
  padding: 0.75rem;
  border-radius: 8px;
  width: 60%;
  color: white;
  text-align: ${(props) => (props.role === "user" ? "right" : "left")};
  background-color: ${(props) =>
    props.role === "user" ? "#006ee6" : "#222831"};
  @media (max-width: 420px) {
    margin-right: 0px;
  }
`;


export const InputWrapper = styled.div`
  padding: 1rem;
  background-color: white;
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: center;
`;

// export const InputWrapper = styled.div`
//   width: 100%;
//   padding: 1rem;
//   border-top: 1px solid #ddd;
//   background-color: #f5f5f5;
//   display: flex;
//   justify-content: center;
//   position: sticky;
//   bottom: 0;
//   z-index: 10;
// `;

export const InputCard = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: 28px;
  box-shadow: rgba(0, 0, 0, 0.18) 0px 10px 24px;
  padding: 0.5rem 1rem;
  min-width: 60%;
`;

export const ExpandingTextarea = styled.textarea`
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 12px;
  padding: 0.75rem 1rem;
  resize: none;
  overflow-y: auto;
  line-height: 1.5;
  max-height: 200px;
  
  @media screen and (min-width: 490px){
    font-size: 1rem;
  }
`;


export const SendButton = styled.button`
  padding: 0.5rem 1rem;
  background-color: #0078d4;
  color: white;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.9rem;
`;

export const ClearButton = styled.button`
  padding: 0.5rem 1rem;
  background-color: #d400007c;
  color: white;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.9rem;
`;

export const CloseButton = styled.button`
  position: fixed;
  top: 100px;
  right: 20px;
  background-color: #006ee6;
  color: white;
  border: none;
  border-radius: 50%;
  padding: 12px;
  font-size: 20px;
  cursor: pointer;
  z-index: 1100;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.1);
  }

  @media (max-width: 600px) {
    top: 90px;
    right: 10px;
    padding: 10px;
    font-size: 20px;
  }
`;